<template>
    <div class="not-found-content">
        <div class="not-found-box">
            <el-empty
                description="You have accessed a resource that does not exist. Please make sure the path is correct."
                :image="imgSrc" image-size="500" />
        </div>

        <div class="button">
            <el-button plain link size="large" @click="goHome">
                首页
            </el-button>

            <el-button plain link size="large" @click="goBack">
                返回
            </el-button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Action } from '@/typeDefine/CommonTypes';
import { useRouter } from 'vue-router';

const router = useRouter()
const imgSrc: string = new URL(`../assets/images/404.jpg`, import.meta.url).href

const goHome: Action = () => {
    router.replace({
        name: 'index'
    })
}

const goBack: Action = () => {
    router.back()
}

</script>

<style lang="css" scoped>
.not-found-content .button {
    display: flex;
    justify-content: center;
}
</style>